import { captureError } from 'app/libs/error-tracker/capture-error';
import { HttpClient } from 'app/libs/http-client';

export const apiClient = new HttpClient({
  log: ({ err, ...extra }) => {
    captureError(err, {
      extra,
    });
  },
});
